jQuery(document).ready(function($) {
    const $blocks = $('.wp-block-jormi-blocks-mobile-booking');
    if ($blocks.length === 0) return;

    $blocks.each(function() {
        const $block = $(this);
        const $trigger = $block.find('button');
        const $panel = $block.find('#booking-panel');
        
        $trigger.on('click', function() {
            const isOpen = $panel.hasClass('open');

            $panel.toggleClass('open'); 
            $trigger.attr('aria-expanded', !isOpen);
            $panel.attr('aria-hidden', isOpen);
            $trigger.css({ zIndex: '999' });

            // Prevent/restore scrolling
            if (!isOpen) {
                $('html, body').css('overflow', 'hidden');
            } else {
                $('html, body').css('overflow', '');
            }
        });
    });
});
